import React from 'react';
import { GridItem, SimpleGrid, Stack, Text } from '@cad-arc';
import { colors } from '../../../../../colors/colors';

const EMPTY_VALUE = '—';

export function SubdivisionGrid(props: {
    cells: { label: string; value?: string }[];
}): React.ReactElement {
    return (
        <SimpleGrid columns={3}>
            {props.cells.map((cell, idx) => {
                return (
                    <GridItem key={idx}>
                        <Stack spacing={0}>
                            <Text
                                variant="headingXs"
                                style={{ color: colors.subdivisionLabel }}
                            >
                                {cell.label}
                            </Text>
                            <Text>{cell.value || EMPTY_VALUE}</Text>
                        </Stack>
                    </GridItem>
                );
            })}
            <GridItem></GridItem>
        </SimpleGrid>
    );
}
